import { render, staticRenderFns } from "./fullPayment.vue?vue&type=template&id=6464aae8&scoped=true"
import script from "./fullPayment.vue?vue&type=script&lang=js"
export * from "./fullPayment.vue?vue&type=script&lang=js"
import style0 from "./fullPayment.vue?vue&type=style&index=0&id=6464aae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6464aae8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/drone/src/components/Breadcrumb/index.vue').default,CouponItem: require('/drone/src/components/CouponItem/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default,OrderPayDialog: require('/drone/src/components/OrderPayDialog/index.vue').default,CouponModal: require('/drone/src/components/CouponModal/index.vue').default})
